// This file is generated by scripts/generate.mjs — do not edit.
// Source: svg/magnifying-glass.svg
import { IconBase } from "./icon-base";
import type { IconProps } from "./types";

export function MagnifyingGlassIcon(props: IconProps) {
	return (
		<IconBase viewBox="0 0 16 16" {...props}>
			<path
				d="M7.5 1.375C10.8827 1.375 13.625 4.11726 13.625 7.5C13.625 8.80392 13.2168 10.012 12.5221 11.0051C12.3751 11.2152 12.3879 11.5032 12.5692 11.6845L14.4424 13.5586C14.686 13.8027 14.6863 14.1985 14.4424 14.4424C14.1985 14.6863 13.8027 14.686 13.5586 14.4424L11.6845 12.5692C11.5032 12.3879 11.2152 12.3751 11.0051 12.5221C10.012 13.2168 8.80392 13.625 7.5 13.625C4.11726 13.625 1.375 10.8827 1.375 7.5C1.375 4.11726 4.11726 1.375 7.5 1.375ZM7.5 2.625C4.80761 2.625 2.625 4.80761 2.625 7.5C2.625 10.1924 4.80761 12.375 7.5 12.375C10.1924 12.375 12.375 10.1924 12.375 7.5C12.375 4.80761 10.1924 2.625 7.5 2.625Z"
				fill="currentColor"
			/>
		</IconBase>
	);
}
